import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { getAtletaPorNumero } from "./utils";

const Athletes = ({
  tiimeSacador,
  setTiimeSacador, // <- Agora controlamos via prop ou estado pai
  idPartida,
  onChangeHome,
  onChangeVisitor,
  funcaoAtleta,
  lastScout,
  numScout,
  numSet,
  onChangeSacador,
  homeLeft,
  onChangeTeams,
}) => {
  const [homeInputs, setHomeInputs] = useState([]);
  const [visitorInputs, setVisitorInputs] = useState([]);
  const [old, setOld] = useState(0);
  const [novo, setNovo] = useState(0);
  const [isHome, setIsHome] = useState("");
  const [clickOrigin, setClickOrigin] = useState("");

  const levantadoresRef = useRef([]);
  const esquerda = homeLeft;

  useEffect(() => {
    if (lastScout && lastScout.Rotation) {
      setHomeInputs(lastScout.Rotation.home || []);
      setVisitorInputs(lastScout.Rotation.away || []);
      levantadoresRef.current = [...lastScout.setters];
    }
  }, [lastScout, homeLeft]);

  const rotate = (team, direction = "normal") => {
    const inputs = team === "home" ? [...homeInputs] : [...visitorInputs];
    if (inputs.length < 6) return;

    let newInputs = [...inputs];
    const fixed = inputs[6];

    if (direction === "normal") {
      newInputs = [
        inputs[1],
        inputs[2],
        inputs[3],
        inputs[4],
        inputs[5],
        inputs[0],
        fixed,
      ];
    } else {
      newInputs = [
        inputs[5],
        inputs[0],
        inputs[1],
        inputs[2],
        inputs[3],
        inputs[4],
        fixed,
      ];
    }

    let home = homeInputs;
    let away = visitorInputs;

    if (team === "home") {
      if (direction === "normal") {
        levantadoresRef.current[0] =
          levantadoresRef.current[0] === 1 ? 6 : levantadoresRef.current[0] - 1;
      } else {
        levantadoresRef.current[0] =
          levantadoresRef.current[0] === 6 ? 1 : levantadoresRef.current[0] + 1;
      }
      setHomeInputs(newInputs);
      home = newInputs;
      onChangeHome(newInputs);
      setIsHome(true);
    } else {
      if (direction === "normal") {
        levantadoresRef.current[1] =
          levantadoresRef.current[1] === 1 ? 6 : levantadoresRef.current[1] - 1;
      } else {
        levantadoresRef.current[1] =
          levantadoresRef.current[1] === 6 ? 1 : levantadoresRef.current[1] + 1;
      }
      setVisitorInputs(newInputs);
      away = newInputs;
      onChangeVisitor(newInputs);
      setIsHome(false);
    }

    setClickOrigin(team);
  };

  const updateInput = (team, index, newValue) => {
    setIsHome(team === "home");
    const inputs = team === "home" ? [...homeInputs] : [...visitorInputs];
    const oldValue = inputs[index];
    setOld(oldValue);
    setNovo(newValue);

    inputs[index] = parseInt(newValue, 10);

    if (team === "home") {
      setHomeInputs(inputs);
      onChangeHome(inputs);
    } else {
      setVisitorInputs(inputs);
      onChangeVisitor(inputs);
    }
  };

  const handleSave = async (
    isRotation = false,
    origin = null,
    home = null,
    away = null
  ) => {
    const donoAcao = isHome ? "*" : "a";

    if (!isRotation && numScout - 1 !== 0 && !origin) {
      const codigo = donoAcao + "c" + old + ":" + novo;
      const novaSubstituicao = {
        "*": homeInputs,
        a: visitorInputs,
        sett: lastScout.setters,
        score: lastScout.score,
        setNum: lastScout.setNum,
        serv: lastScout.serving,
      };
      try {
        const response = await fetchBlocks(codigo, novaSubstituicao, idPartida);
        const teams = {
          home: response.data["*"],
          away: response.data["a"],
        };

        onChangeTeams(teams);

        console.log(log);
      } catch (error) {
        console.error(`Erro no bloco de substituicao`, error);
      }
    } else {
      setClickOrigin("");
      try {
        const novosCampos = {
          homeInputs: home ?? homeInputs,
          visitorInputs: away ?? visitorInputs,
          serving: tiimeSacador,
          alterar: numScout - 1,
          setNum: numSet,
          setters: levantadoresRef.current,
          left: homeLeft, //!aqui
        };
        const response = await axios.put(
          `${
            import.meta.env.VITE_REACT_APP_BACKEND_BASEURL
          }/matches/atletas/${idPartida}`,
          novosCampos
        );
        const resposta = response.data[0];
      } catch (error) {
        console.error("Erro ao salvar alterações:", error);
        alert("Erro ao salvar alterações.");
      }
    }
    window.location.reload();
  };

  const fetchBlocks = async (cod, newScout, idPartida) => {
    const { "*": home, a: away, sett, score, setNum, serv } = newScout;
    const reduzInicial = cod.charAt(0).toLowerCase() + cod.slice(1);

    try {
      const response = await axios.post(
        `${import.meta.env.VITE_REACT_APP_BACKEND_BASEURL}/matches/scout`,
        {
          partida: idPartida,
          home,
          away,
          serv,
          sett,
          score,
          cod: reduzInicial,
          num: setNum,
        }
      );

      return response || null;
    } catch (error) {
      console.error("Erro ao buscar dados do bloco:", error);
      throw error;
    }
  };

  if (!lastScout || !lastScout.Rotation) {
    return <div>Carregando dados da rotação...</div>;
  }

  const totalRows = Math.max(homeInputs.length, visitorInputs.length);

  const ActionButtons = ({ position }) => (
    <div className="flex flex-col items-center space-y-2">
      <button
        type="button"
        tabIndex={0}
        onClick={() => rotate(position, "normal")}
        className="text-gray-400 hover:text-gray-600"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          pointerEvents="none"
        >
          <path d="M5 15l7-7 7 7" />
        </svg>
      </button>
      <button
        tabIndex={0}
        type="button"
        onClick={() => rotate(position, "inverse")}
        className="text-gray-400 hover:text-gray-600"
      >
        <svg
          className="w-4 h-4"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          viewBox="0 0 24 24"
          pointerEvents="none"
        >
          <path d="M19 9l-7 7-7-7" />
        </svg>
      </button>
    </div>
  );

  return (
    <div>
      <table className="table-auto border-collapse border border-gray-300 mx-8">
        <thead>
          <tr>
            <th className="border px-2 py-1"></th>
            <th className="border px-2 py-1"></th>

            <th
              className="border px-2 py-1 cursor-pointer"
              onClick={() => onChangeSacador("*")}
            >
              <span
                className={`${
                  tiimeSacador === "*"
                    ? "text-blue-600 font-bold"
                    : "text-black"
                }`}
              >
                Local
              </span>
            </th>

            <th
              className="border px-2 py-1 cursor-pointer"
              onClick={() => onChangeSacador("a")}
            >
              <span
                className={`${
                  tiimeSacador === "a" ? "text-red-600 font-bold" : "text-black"
                }`}
              >
                Visitante
              </span>
            </th>

            <th className="border px-2 py-1"></th>
            <th className="border px-2 py-1"></th>
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: totalRows }).map((_, index) => (
            <tr key={index}>
              {index === 0 && (
                <td
                  rowSpan={totalRows}
                  className="border px-2 py-1 align-middle"
                >
                  {numScout === 1 && <ActionButtons position="home" />}
                </td>
              )}
              <td className="border px-2 py-1 text-center text-xs">
                {getAtletaPorNumero(homeInputs[index], funcaoAtleta?.home)
                  ?.name || ""}
                <span className="text-red-400 ">
                  {getAtletaPorNumero(homeInputs[index], funcaoAtleta?.home)
                    ?.funcao || ""}
                </span>
              </td>
              <td className="border px-2 py-1">
                <input
                  type="number"
                  value={homeInputs[index] || ""}
                  onChange={(e) => updateInput("home", index, e.target.value)}
                  placeholder={`Jogador ${index + 1}`}
                  className="w-16 text-center border border-gray-300 rounded"
                />
              </td>
              <td className="border px-2 py-1">
                <input
                  type="number"
                  value={visitorInputs[index] || ""}
                  onChange={(e) =>
                    updateInput("visitor", index, e.target.value)
                  }
                  placeholder={`Jogador ${index + 1}`}
                  className="w-16 text-center border border-gray-300 rounded"
                />
              </td>
              <td className="border px-2 py-1 text-left text-xs">
                {getAtletaPorNumero(visitorInputs[index], funcaoAtleta?.away)
                  ?.name || ""}
                <span className="text-red-400 ">
                  {getAtletaPorNumero(visitorInputs[index], funcaoAtleta?.away)
                    ?.funcao || ""}{" "}
                </span>
              </td>
              {index === 0 && (
                <td
                  rowSpan={totalRows}
                  className="border px-2 py-1 align-middle"
                >
                  {numScout === 1 && <ActionButtons position="visitor" />}
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="text-center p-4">
        <button
          className="bg-gray-300 hover:bg-gray-400 w-24 rounded py-1"
          onClick={() => handleSave()}
        >
          Gravar
        </button>
      </div>
    </div>
  );
};

export default Athletes;
